"use strict";var $export=require("./_export");$export($export.S,"Math",{DEG_PER_RAD:Math.PI/180});